import getDoc from '../../../utils/db/getDoc'
import {
  GIFT_WITH_PURCHASE_COLLECTION,
  GIFT_WITH_PURCHASE_DOC_ID,
} from './giftWithPurchaseDefaults'
import {
  isUnsupportedGiftSchemaVersion,
  mapGiftWithPurchaseConfigFromDoc,
} from './mapGiftWithPurchaseConfig'

/**
 * @returns {Promise<{
 *   status: 'missing' | 'ready' | 'unsupported',
 *   config: object | null,
 * }>}
 */
const getGiftWithPurchaseConfig = async () => {
  const doc = await getDoc({
    path: GIFT_WITH_PURCHASE_COLLECTION,
    docId: GIFT_WITH_PURCHASE_DOC_ID,
  })

  if (!doc) {
    return {
      status: 'missing',
      config: null,
    }
  }

  const config = mapGiftWithPurchaseConfigFromDoc(doc)

  if (isUnsupportedGiftSchemaVersion(config)) {
    return {
      status: 'unsupported',
      config,
    }
  }

  return {
    status: 'ready',
    config,
  }
}

export default getGiftWithPurchaseConfig
